/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2022-06-09 12:45:36
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 15:54:04
 */
export default {
  getProfile(state) {
    return state.profile;
  },
  accessToken(state) {
    return state.accessToken;
  },
  getMenuOptions(state) {
    return state.options;
  },
  getCurrentRegion(state) {
    return state.current_region;
  },
  getArticleTitle(state) {
    return state.article_title;
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js